import { useEffect } from 'react';
import {
    Box,
    Typography,
    TableContainer,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    Paper
} from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { getEquipment } from '../../../../../../../actions/rof-burns/rof-actions';

export default function EquipmentList({ projectKey }) {
    const dispatch = useDispatch();
    const equipment = useSelector(state => state.rofBurnsReducer.equipment)?.data;

    useEffect(() => {
        if (projectKey) {
            dispatch(getEquipment(projectKey))
        }
    }, [dispatch, projectKey]);

    const equipmentTableColumns = [
        'Id',
        'Name',
        'Type',
        'Manufacturer',
        'Model',
        'Serial Number',
        'Mass',
        'Mass Unit',
        'Source Document',
    ];

    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 3 }}>
            <Typography variant='h4'>
                Processing Equipment List
            </Typography>
            <Box>
                <TableContainer component={Paper} sx={{ height: 'auto' }}>
                    <Table aria-label='simple table'>
                        <TableHead>
                            <TableRow>
                                {equipmentTableColumns.map((column, index) => (
                                    <TableCell align='left' key={index}>{column}</TableCell>
                                ))}
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {equipment
                                ?.map(item => (
                                    <TableRow
                                        key={item.id}
                                        sx={{
                                            '&:last-child td, &:last-child th': { border: 0 },
                                        }}
                                    >
                                        <TableCell align='left'>{item.id}</TableCell>
                                        <TableCell align='left'>{item.name}</TableCell>
                                        <TableCell align='left'>
                                            {item.type === 'Other' ? `Other: ${item.typeOther}` : item.type}
                                        </TableCell>
                                        <TableCell align='left'>{item.manufacturer}</TableCell>
                                        <TableCell align='left'>{item.model}</TableCell>
                                        <TableCell align='left'>{item.serialNumber}</TableCell>
                                        <TableCell align='left'>{item.mass}</TableCell>
                                        <TableCell align='left'>{item.massUnit}</TableCell>
                                        <TableCell align='left'>
                                            {item.sourceDocument &&
                                                <a href={item.sourceDocument} target='_blank' rel='noopener noreferrer'>
                                                    {item.sourceDocumentName}
                                                </a>
                                            }
                                        </TableCell>
                                    </TableRow>
                                ))}
                        </TableBody>
                    </Table>
                </TableContainer>
            </Box>
        </Box>
    );
}
